module.exports = __webpack_public_path__ + "img/partner35.79a62a2b.png";